import React, { useEffect, useState, ReactElement } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TransactionDialog from "../../components/TransactionDialog";
import SubscriptionStatusBanner from "../../components/SubscriptionStatusBanner";
import SidebarToggleButton from "../../components/SidebarToggleButton";
import {  useSSE } from "../../useSSE";
import { useAuth } from "../../useAuth";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { BulkActionProvider } from "../../contexts/BulkActionContext";
import BulkActionPanel from "../../components/BulkActionPanel";
import {
  BarsOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,

  BellOutlined,
  AppstoreOutlined,
  LoginOutlined,
  ApartmentOutlined,
  FileDoneOutlined,
  SyncOutlined,
  TeamOutlined,
  ExceptionOutlined,
  // QuestionCircleOutlined,
  // ControlOutlined,
  UserOutlined,
  InfoCircleOutlined,
  MobileOutlined,


  DiffOutlined,
  
  SettingOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import {
  Button,
  Typography,

  Divider,
  Dropdown,
  MenuProps,
  GetProp,
  Badge,
  
} from "antd";
import MenuItem from "../../components/MenuItem";
import { canAccess } from "./routeAccess";
import LanguageToggle from "../../components/languageToggle";
import ConnectionStatusIcon from "../../components/ConnectionStatusIcon";
import i18n from "../../i18n";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isSidebarMobileOpen, setisSidebarMobileOpen] = useState(false);
  const [notificationBadge, setNotificationBadge] = useState(false);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [status, setStatus] = useState<"approved" | "declined" | "canceled">(
    "approved"
  );
  const [transactionId, setTransactionId] = useState<string>("");
  const { connect, message, isConnected } = useSSE();
  const [notifications, setNotifications] = useState<
    { type: string; tid: string; timestamp: string }[]
  >([]);

  const { role, logout, userName, token, notification, setNotification, hasCapability } =
    useAuth();
  const auth = { role, hasCapability };
  const navigate = useNavigate();
  const location = useLocation();
const { t } = useTranslation();
  const MenuContent: React.FC = () => {
    return (
      <div className="merchant-sidebar bg-gradient-to-tr from-neo-primary to-neo-primary/90 flex flex-col justify-between h-full no-scrollbar overflow-y-scroll rounded-3xl py-8 shadow-xl">
        <div className="px-6 flex-col">
            <Typography className="text-white font-poppins-700 text-center text-2xl">
              NeoPaas
            </Typography>
            {import.meta.env.VITE_ENV_LABEL && (
              <Typography className="text-white/70 font-poppins-300 text-center text-xs mt-1">
                {import.meta.env.VITE_ENV_LABEL}
              </Typography>
            )}
        </div>

        <div className="mt-12 px-6 flex flex-col gap-y-2">
          <Typography className="font-poppins-600 text-xs text-white/60 uppercase tracking-wider mb-2 px-3">
            {t("menu")}
          </Typography>

          <div>
            <MenuItem
              display={canAccess("/dashboard", auth)}
              current={location.pathname}
              location={"/dashboard"}
              icon={<AppstoreOutlined />}
              title= {t("dashboard")}
              to={() => {
                navigate("/dashboard");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/transactions", auth)}
              icon={<FileDoneOutlined />}
              title={t("transactions")}
              current={location.pathname}
              location={"/transactions"}
              to={() => {
                navigate("/transactions");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/terminals", auth)}
              icon={<ApartmentOutlined />}
              title={t("terminals")}
              current={location.pathname}
              location={"/terminals"}
              to={() => {
                navigate("/terminals");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/discounts", auth)}
              icon={<PercentageOutlined />}
              location={"/discounts"}
              title={t("discounts")}
              current={location.pathname}
              to={() => {
                navigate("/discounts");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/terminal", auth)}
              icon={<MobileOutlined />}
              title={t("terminals")}
              current={location.pathname}
              location={"/terminal"}
              to={() => {
                navigate("/terminal");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/reconciliation", auth)}
              icon={<ExceptionOutlined />}
              location={"/reconciliation"}
              title={t("reconciliation")}
              current={location.pathname}
              to={() => {
                navigate("/reconciliation");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/refunds", auth)}
              icon={<SyncOutlined />}
              title={t("refunds")}
              current={location.pathname}
              location={"/refunds"}
              to={() => {
                navigate("/refunds");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/settlement", auth)}
              icon={<DiffOutlined />}
              title={t("settlement")}
              current={location.pathname}
              location={"/settlement"}
              to={() => {
                navigate("/settlement");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={canAccess("/management", auth)}
              icon={<TeamOutlined />}
              title={t("management")}
              location={"/management"}
              current={location.pathname}
              to={() => {
                navigate("/management");
                setisSidebarMobileOpen(false);
              }}
            />

            <MenuItem
              display={true}
              icon={<SettingOutlined />}
              title={t("settings")}
              current={location.pathname}
              location={"/settings"}
              to={() => {
                navigate("/settings");
                setisSidebarMobileOpen(false);
              }}
            />
          </div>
        </div>

        <div className="p-6">
          <Divider className="border-white/20" />

          <MenuItem
            display={true}
            icon={<LoginOutlined />}
            title={t("logout")}
            to={logout}
          />
        </div>
      </div>
    );
  };

  const NotUnit = (title: string, desc: string, icon: ReactElement) => {
    return (
      <div className="flex justify-between gap-x-3 w-96  max-h-52 items-center  ">
        <div>{icon}</div>

        <div className=" flex flex-1 flex-col justify-start ">
          <Typography className="font-poppins-500 text-sm">{title}</Typography>
          <Typography className="font-poppins-300 text-xs">{desc}</Typography>
        </div>
      </div>
    );
  };

  useEffect(() => {


     
    

    if (message.substring(0, 3) === "TCO") {
      setNotificationBadge(true);
      const notification = {
        type: "TCO",
        tid: message.substring(3, message.length),
        timestamp: new Date().toISOString(),
      };
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        notification,
      ]);
      toast.success(t("Terminal No. {{tid}} is connected", { tid: message.substring(3, message.length) }), {
        position: "top-right",
        autoClose: 5000,
      });
    }


      // setNotificationBadge(true);
      // const notification = {
      //   type: "TCO",
      //   tid: message.substring(3, message.length),
      //   timestamp: new Date().toISOString(),
      // };
      // setNotifications((prevNotifications) => [
      //   ...prevNotifications,
      //   notification,
      // ]);
      // toast.success(t("Terminal No. {{tid}} is connected", { tid: message.substring(3, message.length) }), {
      //   position: "top-right",
      //   autoClose: 5000,
      // });
    

    if (message.substring(0, 3) === "TDI") {
      setNotificationBadge(true);

      const notification = {
        type: "TDI",
        tid: message.substring(3, message.length),
        timestamp: new Date().toISOString(),
      };
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        notification,
      ]);
      toast.warning(t("Terminal No. {{tid}} is disconnected", { tid: message.substring(3, message.length) }), {
        position: "top-right",
        autoClose: 5000,
      });
    }


        if (message.substring(0, 3) === "TAM") {
   //   setNotificationBadge(true);

  

    }
    if (message.substring(0, 3) === "FRC") {
      setNotificationBadge(true);

      const notification = {
        type: "FRC",
        tid: message.substring(3, message.length),
        timestamp: new Date().toISOString(),
      };
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        notification,
      ]);
      toast.info(t("Reconciliation for terminal No. {{tid}} completed, no new transactions", { tid: message.substring(3, message.length) }), {
        position: "top-right",
        autoClose: 5000,
      });
    }
    if (message.substring(0, 3) === "SRC") {
      setNotificationBadge(true);

      const notification = {
        type: "SRC",
        tid: message.substring(3, message.length),
        timestamp: new Date().toISOString(),
      };
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        notification,
      ]);
      toast.success(t("Terminal No. {{tid}} auto reconciliation succeeded", { tid: message.substring(3, message.length) }), {
        position: "top-right",
        autoClose: 5000,
      });
    }

    console.log(message);
  }, [message]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleShowDialog = (status: "approved" | "declined" | "canceled") => {
    setStatus(status);
    setShowDialog(true);
  };

  useEffect(() => {
    if (message.substring(0, 3) === "PAY") {
      const st = message.substring(3, 4);
      const txnId = message.substring(4, message.length);
      setTransactionId(txnId);
      if (st === "0") {
        handleShowDialog("declined");
        toast.error(t("Transaction {{id}} declined", { id: txnId }), {
          position: "top-right",
          autoClose: 5000,
        });
      } else if (st === "1") {
        handleShowDialog("approved");
        toast.success(t("Transaction {{id}} approved", { id: txnId }), {
          position: "top-right",
          autoClose: 5000,
        });
      }
    }
  }, [message, t]);

  // useEffect(() => {
  //   if (role === "cashier") connect();
  // }, [connect, role]);

  useEffect(() => {
    if(role!="MERCHANT") return;
    if (!isConnected) {
      connect(token);
    }
  }, [token,isConnected]);

  useEffect(() => {
    if (location.pathname.startsWith("/settings")) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (role === "ADMIN") {
      navigate("/neopass-admin");
    }
  }, [role, navigate]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);

    const formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);

    return formattedDate + " - " + formattedTime;
  };
  const items: MenuProps["items"] = notifications.map(
    (notification, index) => ({
      label:
        notification.type == "TCO"
          ? NotUnit(
              `Terminal No. ${notification.tid} is connected. `,
              formatDate(notification.timestamp),
              <InfoCircleOutlined className="bg-green-200 p-4 rounded-md text-xl " />
            )
          : notification.type == "FRC"
          ? NotUnit(
            `Reconciliation for terminal No. ${notification.tid} completed, no new transactions.`,
            formatDate(notification.timestamp),
              <InfoCircleOutlined className="bg-red-200 p-4 rounded-md text-xl " />
            )
          : notification.type == "SRC"
          ? NotUnit(
              `Terminal No. ${notification.tid} Auto reconciliation succeeded. `,
              formatDate(notification.timestamp),
              <InfoCircleOutlined className="bg-green-200 p-4 rounded-md text-xl " />
            )
          : NotUnit(
              `Terminal No. ${notification.tid} is Disconnected. `,
              formatDate(notification.timestamp),
              <InfoCircleOutlined className="bg-red-200 p-4 rounded-md text-xl " />
            ),
      key: `${index}`,
    })
  );

  type MenuStyle = GetProp<MenuProps, "style">;

  const style: MenuStyle = {
    maxHeight: 500,
    marginTop: 10,
    overflowY: "scroll",
  };

  const notifictionMenu: MenuProps = {
    items:
      items.length == 0
        ? [
            {
              label: NotUnit(
                `No new notifications `,
                "Terminal connection status will apear here.",
                <InfoCircleOutlined className=" p-4 rounded-md text-xl " />
              ),
              key: 0,
            },
          ]
        : items,
    style: style,
  };

  return (
    <BulkActionProvider>
      <>
      <div
      
      dir={i18n.language=="en"?"ltr":"rtl"}
      className={`flex  min-h-screen dark-mode`}>
        {/* Desktop Sidebar */}

        <div
          className={`fixed inset-y-0 ${i18n.language=="en"?"left-0":"right-0"} w-64 p-3 px-1.5  transform transition-transform 
          duration-300 z-10 hidden lg:block
            
          ${
            isSidebarOpen
              ? `${i18n.language=="en"?"translate-x-0":"translate-x-0"}`
              : `${i18n.language=="en"?"-translate-x-full":"translate-x-full"}`
          }
            
          `}
        >
          <MenuContent />
        </div>

        {/* Mobile Sidebar Overlay */}
        {isSidebarMobileOpen && (
          <div 
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setisSidebarMobileOpen(false)}
          />
        )}

        {/* Mobile Sidebar */}
        <div
          className={`fixed inset-0 ${i18n.language=="en"?"left-0":"right-0"} w-full h-full p-3 px-1.5 transform transition-transform 
          duration-300 z-50 lg:hidden
            
          ${isSidebarMobileOpen ? "translate-x-0" : `${i18n.language=="en"?"-translate-x-full":"translate-x-full"}`}
            
          `}
        >
          <div className="flex flex-col h-full">
            <div className="flex p-3 justify-end w-full">
              <Button
                type="primary"
                icon={i18n.language=="en"?<ArrowLeftOutlined />:<ArrowRightOutlined />}
                onClick={() => setisSidebarMobileOpen(false)}
              />
            </div>
            <MenuContent />
          </div>
        </div>

        {/* Mobile Notifications Overlay */}
        {notification && (
          <div 
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={() => setNotification(false)}
          />
        )}

        {/* Mobile Notifications Panel */}
        <div
          className={`fixed inset-0 ${i18n.language=="en"?"left-0":"right-0"} w-full h-full p-3 px-1.5 transform transition-transform 
          duration-300 z-50 lg:hidden
            
          ${notification ? "translate-x-0" : `${i18n.language=="en"?"-translate-x-full":"translate-x-full"}`}
            
          `}
        >
          <div className="flex flex-col h-full">
            <div className={`flex p-3 ${i18n.language=="en"?"justify-end":"justify-start"} w-full`}>
              <Button
                type="primary"
                icon={i18n.language=="en"?<ArrowLeftOutlined />:<ArrowRightOutlined />}
                onClick={() => setNotification(false)}
              />
            </div>
            
            {/* Notifications Content with white background and brand accents */}
            <div className="bg-white flex flex-col h-full no-scrollbar overflow-y-scroll rounded-3xl py-8 shadow-xl border border-gray-100">
              {/* Header with brand color accent */}
              <div className="px-6 pb-6 border-b-2 border-neo-primary/20">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-neo-primary to-neo-primary/80 flex items-center justify-center shadow-lg">
                    <BellOutlined className="text-white text-xl" />
                  </div>
                  <div>
                    <Typography className="text-neo-primary font-poppins-700 text-2xl">
                      {t("notifications")}
                    </Typography>
                    <Typography className="text-gray-500 font-poppins-400 text-xs">
                      {notifications.length} {notifications.length === 1 ? 'notification' : 'notifications'}
                    </Typography>
                  </div>
                </div>
              </div>

              <div className="mt-6 px-6 flex-1 overflow-y-auto">
                {notifications.length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-center py-12">
                    <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                      <InfoCircleOutlined className="text-5xl text-gray-300" />
                    </div>
                    <Typography className="text-gray-500 font-poppins-500 text-base mb-2">
                      {t("No notifications yet")}
                    </Typography>
                    <Typography className="text-gray-400 font-poppins-400 text-sm">
                      {t("TerminalConnectionUpdates")}
                    </Typography>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {notifications
                      .slice(0)
                      .reverse()
                      .map((notif, index) => (
                        <div
                          key={index}
                          className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200 hover:border-neo-primary/30 hover:shadow-md transition-all"
                        >
                          <div className="flex-shrink-0">
                            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                              notif.type === "TCO" || notif.type === "SRC"
                                ? "bg-green-50 border-2 border-green-200"
                                : "bg-red-50 border-2 border-red-200"
                            }`}>
                              <InfoCircleOutlined
                                className={`text-xl ${
                                  notif.type === "TCO" || notif.type === "SRC"
                                    ? "text-green-600"
                                    : "text-red-600"
                                }`}
                              />
                            </div>
                          </div>
                          <div className="flex-1 min-w-0">
                            <Typography className="font-poppins-500 text-sm text-gray-900 mb-1 leading-relaxed">
                              {notif.type === "TCO"
                                ? `Terminal No. ${notif.tid} is connected`
                                : notif.type === "FRC"
                                ? `Reconciliation for terminal No. ${notif.tid} completed, no new transactions`
                                : notif.type === "SRC"
                                ? `Terminal No. ${notif.tid} auto reconciliation succeeded`
                                : `Terminal No. ${notif.tid} is disconnected`}
                            </Typography>
                            <Typography className="font-poppins-400 text-xs text-gray-500">
                              {formatDate(notif.timestamp)}
                            </Typography>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* main content */}
        <div
      
          className={` flex flex-col transition-all p-2 sm:p-3 gap-y-3 sm:gap-y-4 duration-300 w-full min-w-0
          ${isSidebarOpen ? `${i18n.language=="en"?"lg:ml-64":"lg:mr-64"}` : ""}`}
        >
          {/* Top bar */}
          <div className={`flex ${i18n.language=="en"?"flex-row":"flex-row-reverse"} dark-mode-header justify-between p-3 sm:p-4 px-3 sm:px-6 gap-x-2 sm:gap-x-4 min-h-16 sm:min-h-24 items-center rounded-xl sm:rounded-2xl shadow-md border border-neo-matt/10 relative overflow-hidden`}>
            {/* Intersecting Lines Background */}
            <div className="absolute inset-0 pointer-events-none">
              <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="intersecting-lines" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
                    {/* Random intersecting lines */}
                    <line x1="5" y1="0" x2="55" y2="60" stroke="#44175226" strokeWidth="0.5" fill="none" />
                    <line x1="60" y1="10" x2="0" y2="50" stroke="#44175226" strokeWidth="0.5" fill="none" />
                    <line x1="15" y1="60" x2="45" y2="0" stroke="#44175233" strokeWidth="0.5" fill="none" />
                    <line x1="0" y1="20" x2="60" y2="40" stroke="#44175226" strokeWidth="0.5" fill="none" />
                    <line x1="30" y1="0" x2="30" y2="60" stroke="#4417521a" strokeWidth="0.5" fill="none" />
                  </pattern>
                  <linearGradient id="fade-gradient" x1="100%" y1="0%" x2="0%" y2="0%">
                    <stop offset="0%" stopColor="white" stopOpacity="1" />
                    <stop offset="25%" stopColor="white" stopOpacity="0.6" />
                    <stop offset="50%" stopColor="white" stopOpacity="0.2" />
                    <stop offset="75%" stopColor="white" stopOpacity="0.05" />
                    <stop offset="100%" stopColor="white" stopOpacity="0" />
                  </linearGradient>
                  <mask id="fade-mask">
                    <rect x="0" y="0" width="100%" height="100%" fill="url(#fade-gradient)" />
                  </mask>
                </defs>
                <rect x="0" y="0" width="100%" height="100%" fill="url(#intersecting-lines)" stroke="none" mask="url(#fade-mask)" />
              </svg>
            </div>

            <div className="flex items-center gap-x-2 sm:gap-x-4 relative z-10">
              <Button
                className="text-white bg-neo-primary hover:bg-neo-primary/90 transition-colors lg:hidden"
                type="text"
                size="large"
                icon={<BarsOutlined />}
                onClick={() => setisSidebarMobileOpen(true)}
              />
              
              {/* Logo - shown when sidebar is closed on desktop */}
              {!isSidebarOpen && (
                <div className="hidden lg:flex flex-col items-start animate-fadeIn">
                  <Typography className="text-neo-primary font-poppins-700 text-xl leading-tight">
                    NeoPaas
                  </Typography>
                  {import.meta.env.VITE_ENV_LABEL && (
                    <Typography className="text-neo-primary/60 font-poppins-400 text-xs mt-0.5">
                      {import.meta.env.VITE_ENV_LABEL}
                    </Typography>
                  )}
                </div>
              )}
              
              <div className="hidden lg:block">
                <LanguageToggle icon />
              </div>
            </div>

            <div className="flex items-center justify-end gap-x-2 sm:gap-x-4 relative z-10">
              {/* Language Toggle - visible on mobile */}
              <div className="lg:hidden">
                <LanguageToggle icon />
              </div>

              {/* Vertical Divider */}
              <div className="hidden lg:block h-8 w-px bg-gradient-to-b from-transparent via-neo-matt/30 to-transparent"></div>

            {role=="MERCHANT"&&  <div className="hidden sm:block">
                <ConnectionStatusIcon 
                  isConnected={isConnected} 
                  onReconnect={() => connect(token)} 
                />
              </div>}
                
              {/* Vertical Divider */}
              <div className="hidden lg:block h-8 w-px bg-gradient-to-b from-transparent via-neo-matt/30 to-transparent"></div>

              <Badge size="default" dot={notificationBadge}>
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shadow-sm rounded-full bg-white hover:from-neo-matt/10 hover:to-neo-primary/5 transition-all duration-200 border border-neo-matt/20 hover:border-neo-primary/30 hover:shadow-md">
                  {/* Desktop Dropdown - hidden on mobile */}
                  <div className="hidden lg:block">
                    <Dropdown
                      open={notification}
                      onOpenChange={(open) => {
                        setNotification(open);
                      }}
                      menu={notifictionMenu}
                      trigger={["click"]}
                      overlayClassName="notification-dropdown-overlay"
                    >
                      <Button
                        onClick={() => setNotificationBadge(false)}
                        shape="circle"
                        type="text"
                        size="large"
                        icon={<BellOutlined className="text-lg sm:text-xl text-neo-primary" />}
                      />
                    </Dropdown>
                  </div>
                  
                  {/* Mobile Button - only visible on mobile */}
                  <div className="lg:hidden">
                    <Button
                      onClick={() => {
                        setNotificationBadge(false);
                        setNotification(!notification);
                      }}
                      shape="circle"
                      type="text"
                      size="large"
                      icon={<BellOutlined className="text-lg sm:text-xl text-neo-primary" />}
                    />
                  </div>
                </div>
              </Badge>

              {/* Vertical Divider */}
              <div className="hidden lg:block h-8 w-px bg-gradient-to-b from-transparent via-neo-matt/30 to-transparent"></div>

              <Dropdown
                menu={{
                  items: [
                    {
                      key: 'user-info',
                      label: (
                        <div className="px-2 py-2 min-w-[200px]">
                          <div className="flex items-center gap-x-3 mb-3 pb-3 border-b border-neo-matt/20">
                            <div className="w-12 h-12 rounded-full bg-neo-primary flex justify-center items-center shadow-md">
                              <UserOutlined className="text-white text-xl" />
                            </div>
                            <div className="flex flex-col">
                              <Typography className="font-poppins-600 text-sm text-gray-800">
                                {userName}
                              </Typography>
                              <Typography className="font-poppins-400 text-xs text-neo-primary/70 uppercase tracking-wide">
                                {role}
                              </Typography>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <div className="flex items-center gap-x-2 text-xs text-gray-600">
                              <InfoCircleOutlined className="text-neo-primary" />
                              <span className="font-poppins-400">{t("Account Information")}</span>
                            </div>
                          </div>
                        </div>
                      ),
                      disabled: true,
                    },
                    {
                      type: 'divider',
                    },
                    {
                      key: 'logout',
                      label: (
                        <div className="flex items-center gap-x-2 text-red-600 hover:text-red-700">
                          <LoginOutlined />
                          <span className="font-poppins-500">{t("logout")}</span>
                        </div>
                      ),
                      onClick: () => logout(),
                    },
                  ],
                }}
                trigger={['click']}
                placement="bottomRight"
              >
                <div className="items-center flex bg-white gap-x-2 sm:gap-x-3 rounded-lg sm:rounded-xl p-1.5 sm:p-2 pr-2 sm:pr-4 shadow-sm border border-neo-matt/20 hover:border-neo-primary/30 transition-all duration-200 cursor-pointer">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 rounded-full flex justify-center items-center shadow-md">
                    <UserOutlined className="text-neo-primary text-base sm:text-xl" />
                  </div>

                  <div className="hidden sm:flex flex-col justify-center">
                    <Typography className="font-poppins-600 text-sm text-gray-800">
                      {userName}
                    </Typography>
                    <Typography className="font-poppins-400 text-xs text-neo-primary/70 uppercase tracking-wide">
                      {role}
                    </Typography>
                  </div>
                </div>
              </Dropdown>
            </div>
          </div>

          <div className="hidden lg:block">
            <SidebarToggleButton isOpen={isSidebarOpen} onClick={toggleSidebar} />
          </div>

{/* Subscription Status Banner for Merchants */}
          <SubscriptionStatusBanner />

{/* Content container - full width on mobile, responsive on desktop */}
          <div className="w-full min-w-0 py-3 px-2 sm:py-4 sm:px-4 lg:py-8 lg:px-8 flex flex-1 bg-white rounded-xl sm:rounded-2xl shadow-sm border border-neo-matt/10 overflow-hidden">
            {children}
          </div>
        </div>

        {showDialog && (
          <TransactionDialog
            transactionId={transactionId}
            status={status}
            onClose={handleCloseDialog}
          />
        )}
      </div>
      <BulkActionPanel />
      </>
    </BulkActionProvider>
  );
};

export default Layout;
